import React from 'react';
import styles from './teamSubmission.module.scss';

export default class LoadFromLastRoundButton extends React.Component{
    constructor(props){
        super(props);
        if (!props.OnActivate){
            throw new Error('Must define OnActivate method for LoadFromLastRoundButton');
        }
    }

    render(){
        if (this.props.Round.roundNumber <= 1){
            return (<span></span>);
        }

        const activateWrapper = event => {
            event.preventDefault();
            this.props.OnActivate({
                year: this.props.Round.year, 
                roundNumber: this.props.Round.roundNumber - 1
            });
        }

        return (
            <button className={styles.buttonLink} onClick={activateWrapper}>Load from last round</button>
        );
    }
}